/* eslint-disable no-console */
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import { Router } from 'react-router-dom';

import AuthProvider from './auth/AuthProvider';
import ErrorBoundary from './components/common/splash/errorboundary';
import history from './utils/history';
import Root from './containers/Root';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { AppProvider } from './global-context/AppContext';

function App() {
  if (process.env.NODE_ENV === 'production') {
    console.log =
      console.error =
      console.info =
      console.debug =
      console.warn =
      console.trace =
      console.dir =
      console.dirxml =
      console.group =
      console.groupEnd =
      console.time =
      console.timeEnd =
      console.assert =
      console.profile =
        function () {
          // do not log in production
        };
  }

  const queryClient = new QueryClient();

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AppProvider>
          <AuthProvider>
            <Router history={history}>
              <Root />
            </Router>
          </AuthProvider>
        </AppProvider>
        <ReactQueryDevtools initialIsOpen={false} position='bottom-right' />
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
